var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvangardLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 79,
    viewBox: "0 0 81 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8644_176227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.85836 74.9738H3.57229L3.04305 76.5142H0.586407L3.95935 67.6592H6.47127L9.84422 76.5142H7.38758L6.85836 74.9738ZM6.25013 73.2283L5.21532 70.2817L4.18053 73.2283H6.25013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2693 67.6592H15.6975C16.5112 67.6592 17.1273 67.8567 17.5538 68.2437C17.9804 68.6387 18.1858 69.1996 18.1858 69.9344C18.1858 70.3842 18.1068 70.7476 17.9488 71.0481C17.7908 71.3401 17.5459 71.5929 17.2142 71.7904C17.5459 71.8537 17.8224 71.9482 18.0515 72.0749C18.2806 72.201 18.4701 72.3593 18.6123 72.5488C18.7545 72.7383 18.8572 72.9514 18.9204 73.1806C18.9836 73.4178 19.0152 73.6706 19.0152 73.9309C19.0152 74.3496 18.9441 74.7129 18.8019 75.0371C18.6597 75.3608 18.4544 75.6297 18.1937 75.8508C17.933 76.0719 17.6092 76.2378 17.2379 76.3403C16.8666 76.4428 16.44 76.5062 15.9661 76.5062H12.2693V67.6592ZM14.5759 71.1351H15.0024C15.7213 71.1351 16.0846 70.8506 16.0846 70.2817C16.0846 69.7127 15.7213 69.4207 15.0024 69.4207H14.5759V71.1351ZM14.5759 74.729H15.0814C15.658 74.729 16.0767 74.6577 16.3295 74.5079C16.5822 74.3576 16.7086 74.1209 16.7086 73.7887C16.7086 73.457 16.5822 73.2203 16.3295 73.07C16.0767 72.9202 15.666 72.8489 15.0814 72.8489H14.5759V74.729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1118 74.9738H23.8257L23.2965 76.5142H20.8398L24.2049 67.6592H26.7168L30.0898 76.5142H27.6331L27.1118 74.9738ZM26.4956 73.2283L25.4609 70.2817L24.426 73.2283H26.4956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8214 71.0798H38.147V67.6592H40.4535V76.5142H38.147V72.865H34.8214V76.5142H32.5227V67.6592H34.8214V71.0798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7159 76.5142V67.6592H48.7793V69.6102H46.0145V76.5142H43.7159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7889 74.9738H53.5031L52.9738 76.5142H50.5171L53.89 67.6592H56.402L59.7748 76.5142H57.3182L56.7889 74.9738ZM56.1808 73.2283L55.146 70.2817L54.1112 73.2283H56.1808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5066 76.5142H62.2078V67.6592H65.8732C66.8683 67.6592 67.6267 67.92 68.1559 68.4332C68.6851 68.9468 68.946 69.6816 68.946 70.6214C68.946 71.5613 68.6851 72.288 68.1559 72.8097C67.6267 73.3309 66.8602 73.5837 65.8732 73.5837H64.5066V76.5142ZM64.5066 71.7271H65.2726C66.1179 71.7271 66.5446 71.3562 66.5446 70.6214C66.5446 69.8866 66.1179 69.5157 65.2726 69.5157H64.5066V71.7271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9082 74.5632C72.2082 74.5632 72.3977 74.4763 72.4927 74.3024C72.5872 74.1285 72.6269 73.8681 72.6269 73.5364V67.6592H79.8862V74.5632H80.9999V78.1652H78.7091V76.5062H73.3853V78.1652H71.0945V74.5632H71.9082ZM77.5793 69.6102H74.9257V73.56C74.9257 73.7887 74.9176 73.9787 74.9096 74.1365C74.894 74.2943 74.8704 74.4365 74.8307 74.5707H77.5793V69.6102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6124 21.8027H10.6382L17.0079 26.6395H27.9535L29.6124 21.8027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3981 34.5515L28.9973 35.7584L29.3981 34.5515Z",
    fill: "#3DF0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9742 21.8027L53.6282 26.6395H64.5786L70.9483 21.8027H51.9742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7003 29.6309L55.8884 33.2608L60.5388 29.6309H54.7003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8445 29.6309L25.6563 33.2608L21.0059 29.6309H26.8445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.793 57.6078L40.791 0L21.7935 57.6078L29.0393 52.4588L40.791 15.5773L52.3472 52.3191L59.793 57.6078Z",
    fill: "#DA291C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7154 39.1041L40.8935 37.6782L38.8805 39.2066L36.2711 47.3936L40.8935 44.1132L45.3155 47.2538L42.7154 39.1041Z",
    fill: "#DA291C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8644_176227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.4136,
    height: 78.4032,
    fill: "white",
    transform: "translate(0.586426)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvangardLogo);
export default __webpack_public_path__ + "static/media/avangard-logo.47c98cee.svg";
export { ForwardRef as ReactComponent };